import PageLayer from "@Layouts/views/PageLayer";
import FnILayer from "@/DataPages/components/FniManagement/FniLayer";

// Icons
import CIT from "@/assets/icons/dataPages/cit/CIT.svg";

export default function Cit() {
	return (
		<PageLayer title={"F&I Management"} icon={CIT}>
			<FnILayer />
		</PageLayer>
	);
}
